import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const CopaPlata = ({ isAdmin }) => {
  const [categorias, setCategorias] = useState([]);
  const [categoriaSeleccionada, setCategoriaSeleccionada] = useState(null);
  const [playoffData, setPlayoffData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchCategorias();
  }, []);

  const fetchCategorias = async () => {
    try {
      const response = await axios.get(`${API}/categorias`);
      setCategorias(response.data);
    } catch (error) {
      console.error('Error al obtener categorías:', error);
    }
  };

  const fetchPlayoff = async (categoria) => {
    setLoading(true);
    try {
      const response = await axios.get(`${API}/playoffs/${categoria}/plata`);
      setPlayoffData(response.data);
      setCategoriaSeleccionada(categoria);
    } catch (error) {
      console.error('Error al obtener playoff:', error);
      setPlayoffData(null);
    } finally {
      setLoading(false);
    }
  };

  const cargarResultado = async (fase, partidoIdx) => {
    const goles1 = prompt('Goles Equipo 1:');
    const goles2 = prompt('Goles Equipo 2:');

    if (goles1 === null || goles2 === null) return;

    const g1 = parseInt(goles1);
    const g2 = parseInt(goles2);

    if (isNaN(g1) || isNaN(g2) || g1 < 0 || g2 < 0) {
      alert('Goles inválidos');
      return;
    }

    if (g1 === g2) {
      alert('No puede haber empates en playoffs');
      return;
    }

    try {
      await axios.post(`${API}/playoffs/resultado`, {
        categoria: categoriaSeleccionada,
        tipo: 'plata',
        fase: fase,
        partido_idx: partidoIdx,
        goles1: g1,
        goles2: g2
      });
      await fetchPlayoff(categoriaSeleccionada);
      alert('Resultado cargado exitosamente');
    } catch (error) {
      console.error('Error al cargar resultado:', error);
      alert(error.response?.data?.detail || 'Error al cargar resultado');
    }
  };

  const renderPartido = (partido, fase, idx) => {
    if (!partido) return null;

    const hasEquipos = partido.equipo1 && partido.equipo2;
    const hasResultado = partido.goles1 !== null && partido.goles2 !== null;

    return (
      <div key={partido.id || idx} className="playoff-partido">
        <div className={`playoff-equipo ${partido.ganador === partido.equipo1 ? 'ganador' : ''}`}>
          <span className="equipo-nombre">{partido.equipo1 || 'TBD'}</span>
          {hasResultado && <span className="equipo-goles">{partido.goles1}</span>}
        </div>
        <div className="vs-separator">vs</div>
        <div className={`playoff-equipo ${partido.ganador === partido.equipo2 ? 'ganador' : ''}`}>
          <span className="equipo-nombre">{partido.equipo2 || 'TBD'}</span>
          {hasResultado && <span className="equipo-goles">{partido.goles2}</span>}
        </div>
        {isAdmin && hasEquipos && !hasResultado && (
          <button 
            className="btn-cargar-resultado"
            onClick={() => cargarResultado(fase, idx)}
          >
            ⚽ Cargar Resultado
          </button>
        )}
      </div>
    );
  };

  return (
    <div className="copa-plata-container">
      <h2 className="copa-title">🥈 COPA DE PLATA</h2>

      <div className="categoria-selector">
        <label>Seleccionar Categoría:</label>
        <select 
          value={categoriaSeleccionada || ''} 
          onChange={(e) => fetchPlayoff(e.target.value)}
        >
          <option value="">-- Seleccionar --</option>
          {categorias.map(cat => (
            <option key={cat.id} value={cat.año}>{cat.año}</option>
          ))}
        </select>
      </div>

      {loading && <p className="loading-text">Cargando...</p>}

      {playoffData && (
        <div className="playoff-bracket">
          {/* Semifinales */}
          <div className="playoff-fase">
            <h3 className="fase-title">Semifinales de Plata</h3>
            <div className="partidos-grid">
              {playoffData.fase.semifinales.map((partido, idx) => 
                renderPartido(partido, 'semifinales', idx)
              )}
            </div>
          </div>

          {/* Final */}
          <div className="playoff-fase">
            <h3 className="fase-title">🥈 FINAL DE PLATA</h3>
            <div className="partidos-grid final-grid">
              {renderPartido(playoffData.fase.final, 'final', 0)}
            </div>
            {playoffData.fase.final.ganador && (
              <div className="campeon-container campeon-plata">
                <h2 className="campeon-title">🎉 CAMPEÓN DE PLATA: {playoffData.fase.final.ganador} 🎉</h2>
              </div>
            )}
          </div>
        </div>
      )}

      {!playoffData && categoriaSeleccionada && !loading && (
        <p className="info-message">
          📌 Los playoffs de plata se generan automáticamente cuando se genera la Copa de Oro
        </p>
      )}
    </div>
  );
};

export default CopaPlata;
